import React, { Component } from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { connect } from 'react-redux';
import DmtLogo from '../components/Logos/Logo_DMT_Titel_cropped.jpg';
import SportKinderLogo from '../components/Logos/Sport Kinder Berlin - Logo klein jpg.jpg';
import { FaUsers, FaSignOutAlt, FaLock, FaDownload } from 'react-icons/fa';

class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
    }

    downloadAnleitung = () => {
    axios({
        url: this.props.apiUri + 'Kind/DownloadAnleitung',
        method: 'GET',
        responseType: 'blob', // important
        headers: { 'Authorization': `Bearer ${this.props.token}` }
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = "Anleitung.pdf";

        // link.setAttribute('download', this.state.selectedKind.nachname + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    });
}

  render () {
    let dmtLogo = (
      <div>
          <img
              alt=""
              src={DmtLogo}
              width="140"
              height="60"
              className=""
          />
      </div>
  );

  let sportKinderLogo = (
      <div>
          <img
              alt=""
              src={SportKinderLogo}
              width="100"
              height="50"
              className="d-inline-block align-top"
          />
      </div>
  );

    let authItem = (
      // <NavItem>
      //   <NavLink tag={Link} className="text-dark" to="/auth">Einloggen</NavLink>
      // </NavItem>
      <Nav.Link href="/auth">Einloggen</Nav.Link>
    );
    let stammdatenItem = null;
    let ergebnisseItem = null;
    let testItem = null;
      let auswertungItem = null;
      let userItem = null;
      if (this.props.isAuth) {
          
        //authItem = ( 
        //    // <NavItem>
        //    //   <NavLink tag={Link} className="text-dark" to="/logout">{this.props.username} Ausloggen</NavLink>
        //    // </NavItem>
        //    //<Nav.Link href="/logout"><FaUser size={18} /> {this.props.username}</Nav.Link>
        //    <NavDropdown title="Benutzer" id="basic-nav-dropdown">
        //        <NavDropdown.Item href="/download">Anleitung</NavDropdown.Item>
        //      <NavDropdown.Item href="/updateUser">Passwort �ndern</NavDropdown.Item>
        //      <NavDropdown.Divider />
        //      <NavDropdown.Item href="/logout">Ausloggen</NavDropdown.Item>
        //      </NavDropdown>
        //);

       
          if (this.props.userLevel == 0) {
              // Admins k�nnen sehen:
              ergebnisseItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/ergebnisse">Ergebnisse</NavLink>
                  // </NavItem>

                  <Nav.Link href="/ergebnisse">Ergebnisse</Nav.Link>
              );
              testItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/start-test">Test</NavLink>
                  // </NavItem>
                  <Nav.Link href="/start-test">Test</Nav.Link>
              );
              auswertungItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/auswertung">Auswertung</NavLink>
                  // </NavItem>
                  <Nav.Link href="/auswertung">Auswertung</Nav.Link>
              );
              stammdatenItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/stammdaten">Stammdaten</NavLink>
                  // </NavItem>    
                  <Nav.Link href="/stammdaten">Stammdaten</Nav.Link>
              );
              authItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/logout">{this.props.username} Ausloggen</NavLink>
                  // </NavItem>
                  //<Nav.Link href="/logout"><FaUser size={18} /> {this.props.username}</Nav.Link>
                  <NavDropdown title="Benutzer" id="basic-nav-dropdown">
                    
                      <NavDropdown.Item onClick={() => this.downloadAnleitung()}><FaDownload size={18} /> Anleitung</NavDropdown.Item>
                      <NavDropdown.Item href="/benutzer"><FaUsers size={18} /> Benutzerverwaltung</NavDropdown.Item>
                      <NavDropdown.Item href="/updatePassword"><FaLock size={18} /> Passwort aendern</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/logout"><FaSignOutAlt size={18}/> Ausloggen</NavDropdown.Item>
                  </NavDropdown>
              );
          }
          else {
              testItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/start-test">Test</NavLink>
                  // </NavItem>
                  <Nav.Link href="/start-kita-test">Kita-Test starten</Nav.Link>
              );
              ergebnisseItem = (
                  <Nav.Link href="/kita-ergebnisse">Ergebnisse</Nav.Link>
              );
              stammdatenItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/stammdaten">Stammdaten</NavLink>
                  // </NavItem>    
                  <Nav.Link href="/kita-stammdaten">Stammdaten</Nav.Link>
              );
              authItem = (
                  // <NavItem>
                  //   <NavLink tag={Link} className="text-dark" to="/logout">{this.props.username} Ausloggen</NavLink>
                  // </NavItem>
                  //<Nav.Link href="/logout"><FaUser size={18} /> {this.props.username}</Nav.Link>
                  <NavDropdown title="Benutzer" id="basic-nav-dropdown">
                      <NavDropdown.Item onClick={() => this.downloadAnleitung()}><FaDownload size={18} /> Anleitung</NavDropdown.Item>
                      <NavDropdown.Item href="/updatePassword"><FaLock size={18} /> Passwort aendern</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/logout"><FaSignOutAlt size={18} /> Ausloggen</NavDropdown.Item>
                  </NavDropdown>
              );
          }
    }
    return (
      <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="/">{dmtLogo}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            {ergebnisseItem}
            {stammdatenItem}
            {testItem}
            {auswertungItem}
            {userItem}
            {authItem}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    );
  }
}

const mapStateToProps = state => {
  return {
      isAuth: state.token !== null,
      username: state.username,
      apiUri: state.apiUri,
      token: state.token,
      userLevel: state.userLevel
  };
};

export default connect(mapStateToProps)(NavMenu);
